import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function NewsletterForm({ source = "website", compact = false }) {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!consent) {
      setError("Explicit consent is required to subscribe.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email, consent, source });
      setDone(true);
      toast.success("Subscription confirmed. Welcome email sent.");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div data-testid="newsletter-success" className="border border-hussar-gold/30 bg-hussar-gold/5 px-6 py-5">
        <p className="font-serif text-hussar-gold text-lg">You are on the record.</p>
        <p className="text-hussar-slate text-sm mt-2 font-light">
          A confirmation has been sent to your inbox. One disciplined research note, weekly. Nothing else.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className={compact ? "" : "max-w-xl"}>
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@address.com"
          data-testid="newsletter-email-input"
          className="field-input flex-1"
        />
        <button type="submit" disabled={loading} data-testid="newsletter-subscribe-btn" className="btn-gold whitespace-nowrap disabled:opacity-50">
          {loading ? "Recording…" : "Subscribe"} <ArrowRight size={14} />
        </button>
      </div>
      <label className="flex items-start gap-3 mt-4 cursor-pointer group">
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          data-testid="newsletter-consent-checkbox"
          className="mt-1 accent-[#C5A059]"
        />
        <span className="text-xs text-hussar-muted leading-relaxed group-hover:text-hussar-slate transition-colors">
          I explicitly consent to receive Hussar Treasury Weekly Intelligence by email. I can unsubscribe at any time.
          My address is never shared, sold, or shown publicly.
        </span>
      </label>
      {error && <p data-testid="newsletter-error" className="text-red-400 text-xs mt-3 font-mono">{error}</p>}
    </form>
  );
}
